import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { html } from "lit";
import "../IconButton/index.js";
import "../../atom/Row/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfHeader = class extends BaseComponent {
  render() {
    return html`
      <nav class="row flex w-full px-24 py-12">
        <dsf-row dsf_gap="s" dsf_justify="left" dsf_basis="3">
          <slot name="breadcrumbs"></slot>
        </dsf-row>
        <dsf-row dsf_gap="s" dsf_justify="right" dsf_basis="1" dsf_grow="0">
          <slot name="CTA"></slot>
          <slot name="navigation"></slot>
        </dsf-row>
      </nav>
    `;
  }
};
DsfHeader.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfHeader = __decorateClass([
  defineElement("dsf-header")
], DsfHeader);
export {
  DsfHeader
};
